// middleware/auth.ts

import { routeRoles } from "~/config/route-roles"
import {
  ADMIN_ROLE_SLUG,
  OPERATIONS_DIRECTOR_ROLE_SLUG,
  isOperationsDirectorDeniedPath,
} from "~/config/role-access"
import { REFUNDS_SECTION_ENABLED } from "~/config/features"

export default defineNuxtRouteMiddleware(async (to, from) => {
    const auth_store = useAuthStore()

    const cookie = useCookie('token')
    
    // Если есть токен, но нет пользователя - загружаем информацию о пользователе
    if (cookie.value && !auth_store.user) {
      auth_store.token = cookie.value
      // Загружаем данные пользователя
      await auth_store.get_user()
    }

	if (to.path == '/login') {
		return
	}

	if (to.path == '/access-denied') {
		return
	}

	// Если пользователь не авторизован
	if (!auth_store.user) {
		return navigateTo({
			path: '/login',
			query: { redirect: to.fullPath },
		});
	}

	if (!REFUNDS_SECTION_ENABLED && to.path.startsWith('/refunds')) {
		return navigateTo('/')
	}

  const userRoles = auth_store.user?.roles_slugs ?? []
  const isAdmin = userRoles.includes(ADMIN_ROLE_SLUG)
  const isOperationsDirector = userRoles.includes(OPERATIONS_DIRECTOR_ROLE_SLUG)
  const isAdminEquivalent = isAdmin || isOperationsDirector
  const hasCommunicationsMainAccess = userRoles.includes('communications_view') || userRoles.includes('communications_manage')
  const hasCommunicationsAlertAccess = userRoles.includes('communications_alert_manage')

	// Проверяем, есть ли у пользователя доступ к маршруту
	const hasAccess = routeRoles.some((rule) => {
		// Проверяем, соответствует ли путь регулярке
		if (rule.path.test(to.path)) {
			// Проверяем, есть ли у пользователя хотя бы одна из нужных ролей
			return rule.roles.some((role) => {
        if (role === '*') return true
        if (userRoles.includes(role)) return true

        if (
          role === ADMIN_ROLE_SLUG &&
          isOperationsDirector &&
          !isOperationsDirectorDeniedPath(to.path)
        ) {
          return true
        }

        return false
      });
		}
		return false;
	});

	// Если доступа нет, редиректим на страницу "нет доступа"
		if (!hasAccess) {

		if (auth_store?.user?.roles_slugs?.includes('admin_deposit_rub')) {
			return navigateTo('/fg')
		}

		if (auth_store?.user?.roles_slugs?.includes('admin_fin')) {
			return navigateTo('/fin/expenses')
		}

		if (auth_store?.user?.roles_slugs?.includes('trader_deposit_rub')) {
			return navigateTo('/trader_deposit_rub')
		}

    if (isOperationsDirector) {
      return navigateTo('/')
    }

	    if (auth_store?.user?.roles_slugs?.includes('marketer')) {
				if (hasCommunicationsMainAccess) {
					return navigateTo('/communications/push-rules')
				}
				return navigateTo('/main_report')
			}

			if (hasCommunicationsMainAccess) {
				return navigateTo('/communications/push-rules')
			}

			if (hasCommunicationsAlertAccess) {
				return navigateTo('/communications/tma-modal-alert')
			}

			if (auth_store?.user?.roles_slugs?.includes('communications_stats_view')) {
				return navigateTo('/communications/stats')
			}

		return navigateTo({
			path: '/access-denied',
			query: { redirect: to.fullPath },
		});
	}
    
    // Список защищенных маршрутов
    const protectedRoutes = [
      '/lists',
      '/dashboard',
      // Добавьте другие защищенные маршруты
    ]

    // Проверяем, является ли текущий маршрут защищенным
    const isProtectedRoute = protectedRoutes.some(route => to.path.startsWith(route))

    // Если маршрут защищенный и нет токена - редиректим на логин
    if (isProtectedRoute && !cookie.value) {
      // Показываем модальное окно авторизации
      useAuthStore().auth_modal_show()
      useToast().add({
        title: 'Доступ запрещен',
        description: 'Пожалуйста, авторизуйтесь для доступа к этой странице',
        color: 'red',
        // timeout: 5000,
      })
      // Или редиректим на страницу логина
      // return navigateTo('/login')


      
      // Если хотим сохранить URL для редиректа после логина
      return navigateTo(`/?redirect=${to.fullPath}`)
    }

    if (to.path.startsWith('/cc') && !isAdmin) {
      return navigateTo('/')
    }
    
    // Если пользователь авторизован и идет на страницу логина - редиректим на главную
    if (cookie.value && to.path === '/login') {
      return navigateTo('/')
    }

    if (to.path == '/' && !isAdminEquivalent && auth_store.user?.roles_slugs?.includes('trader_deposit_rub')) {
      return navigateTo('/trader_deposit_rub')
    }

	    if (to.path == '/' && !isAdminEquivalent && !auth_store.user?.roles_slugs?.includes('fin_reports') && auth_store.user?.roles_slugs?.includes('admin_deposit_rub')) {
	      return navigateTo('/fg')
	    }

		if (
			to.path == '/' &&
			!isAdminEquivalent &&
			!hasCommunicationsMainAccess &&
			!hasCommunicationsAlertAccess &&
			auth_store?.user?.roles_slugs?.includes('communications_stats_view')
		) {
			return navigateTo('/communications/stats')
		}
  })
